import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class MonographyParent extends List {
  constructor(obj) {
    super(Monography, obj)
  }
}

export class Monography {
  constructor(obj) {
    this.id = obj?.id || null
    this.authoPartName = obj?.authoPartName || null
    this.authoPartPage = obj?.authoPartPage || null
    this.chapterNumber = obj?.chapterNumber || null
    this.checker = obj?.checker || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.doi = obj?.doi || null
    this.edition = obj?.edition || null
    this.foreignPublishingHouseName = obj?.foreignPublishingHouseName || null
    this.isForeign = obj?.isForeign || false
    this.isForeignPublishingHouse = obj?.isForeignPublishingHouse || false
    this.isbn = obj?.isbn || null
    this.pageCount = obj?.pageCount || null
    this.partNumber = obj?.partNumber || null
    this.publicationForm = obj?.publicationForm || null
    this.publishingHouse = obj?.publishingHouse || null
    this.redactor = obj?.redactor || null
    this.secondPublishingHouse = obj?.secondPublishingHouse || null
    this.series = obj?.series || null
    this.state = obj?.state || null
    this.foreignState = obj?.foreignState || null
    this.tome = obj?.tome || null
    this.tomeCount = obj?.tomeCount || null
    this.pageFrom = obj?.pageFrom || null
    this.pageTo = obj?.pageTo || null
    this.notFoundAuthor = obj?.notFoundAuthor || null
    this.link = obj?.link || null
  }

  get fullBibliographicDescription() {
    let optionalPart = null,
      series = '',
      doi = ''
    const authors = this.commonWork.authors.list
      .map(el => (this.isForeign || el.isForeignAuthor ? el.getMainAuthorShortNameEng() : el.getMainAuthorShortName()))
      .filter(el => el)
    const authorPartPage =
      this.pageFrom === this.pageTo ? ` – с. ${this.pageFrom}` : ` – с. ${this.pageFrom}-${this.pageTo}.`

    if (this.authoPartName && this.commonWork.workName) {
      optionalPart = `${this.authoPartName}. Глава ${this.authoPartPage}.${
        this.pageFrom && this.pageTo ? authorPartPage : ''
      } в кн. ${this.commonWork.workName}: `
    }

    if (this.series) series = ` – Серия «${this.series}».`
    if (this.doi) doi = `. DOI: ${this.doi}`

    const publishingHouseName = this.isForeignPublishingHouse
      ? this.foreignPublishingHouseName
      : (this.publishingHouse && this.publishingHouse.name) || ''

    if (
      authors.length &&
      this.commonWork.workName &&
      this.redactor &&
      publishingHouseName &&
      this.pageCount &&
      this.isbn
    ) {
      const tomeInfo = this.tome ? `: в ${this.tomeCount} т. – Т. ${this.tome}. ` : ''
      return `${authors.join(', ')} ${optionalPart || this.commonWork.workName} ${tomeInfo}- под ред. ${
        this.redactor
      }. – ${publishingHouseName}.${series} – Кол-во страниц монографии (${this.pageCount} с.) ${doi} (${this.isbn})`
    } else {
      return null
    }
  }

  getForAPI() {
    return {
      id: this.id,
      authoPartName: this.authoPartName,
      authoPartPage: this.authoPartPage,
      pageFrom: this.pageFrom,
      pageTo: this.pageTo,
      chapterNumber: this.chapterNumber,
      checker: this.checker,
      commonWork: this.commonWork.getForAPI(),
      doi: this.doi,
      edition: this.edition,
      foreignPublishingHouseName: this.foreignPublishingHouseName,
      fullBibliographicDescription: this.fullBibliographicDescription,
      isForeign: this.isForeign,
      isForeignPublishingHouse: this.isForeignPublishingHouse,
      isbn: this.isbn,
      pageCount: this.pageCount,
      partNumber: this.partNumber,
      publicationForm: this.publicationForm,
      publishingHouse: this.publishingHouse,
      redactor: this.redactor,
      secondPublishingHouse: this.secondPublishingHouse,
      series: this.series,
      state: this.state,
      foreignState: this.foreignState,
      tome: this.tome,
      tomeCount: this.tomeCount,
      notFoundAuthor: this.notFoundAuthor,
      link: this.link
    }
  }
}
